import { Link } from 'react-router-dom';

export default function SEOArticleSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="mb-6">
          <span className="text-xs font-medium text-accent-600 tracking-widest uppercase">
            Guida SEO
          </span>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="flex-1">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              Itaobuy Sheet: La Guida Definitiva per Acquisti Intelligenti nel 2026
            </h2>
            <div className="text-foreground-600 leading-relaxed space-y-4 text-sm md:text-base">
              <p>
                <strong>Itaobuy Spreadsheet</strong> è uno strumento essenziale per chi desidera 
                effettuare acquisti online in modo intelligente e organizzato. Questa guida completa 
                ti accompagnerà attraverso tutte le funzionalità, i vantaggi e le migliori strategie 
                per utilizzare al meglio questo potente shopping agent.
              </p>
              <p>
                Che tu sia un principiante o un acquirente esperto, Itaobuy Spreadsheet ti offre 
                gli strumenti necessari per confrontare prodotti, verificare la qualità attraverso 
                QC photos e gestire i tuoi ordini in modo efficiente. La piattaforma si distingue 
                per la sua interfaccia intuitiva e le funzionalità avanzate di ricerca prodotti.
              </p>
              <p>
                Con oltre 14 categorie di prodotti disponibili — dalle scarpe agli accessori, 
                dall&apos;abbigliamento ai profumi — Itaobuy Spreadsheet rappresenta la soluzione 
                ideale per chi cerca un&apos;esperienza di shopping internazionale sicura e affidabile. 
                La trasparenza nelle informazioni e la qualità del servizio sono i pilastri 
                fondamentali della nostra piattaforma.
              </p>
            </div>
            <Link
              to="/articolo/"
              className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Leggi l&apos;articolo completo
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-[380px]">
            <div className="grid grid-cols-2 gap-5">
              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <span className="block font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-1">
                  14+
                </span>
                <span className="text-xs text-foreground-500">Categorie Prodotto</span>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <span className="block font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-1">
                  100%
                </span>
                <span className="text-xs text-foreground-500">Link Verificati</span>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <span className="block font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-1">
                  99%
                </span>
                <span className="text-xs text-foreground-500">Soddisfazione Utenti</span>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <span className="block font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-1">
                  24/7
                </span>
                <span className="text-xs text-foreground-500">Supporto Ricerche</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}